"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SelectOnUpManager_eventEngine, _SelectOnUpManager_tree, _SelectOnUpManager_deselectOnEmpty, _SelectOnUpManager_effectMaterialToken, _SelectOnUpManager_filter, _SelectOnUpManager_groupEffectMaterialToken, _SelectOnUpManager_groupedNodes, _SelectOnUpManager_intersection, _SelectOnUpManager_node;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOnUpManager = void 0;
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const InteractionData_1 = require("../InteractionData");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class SelectOnUpManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor() {
        // #region Properties (9)
        super(...arguments);
        _SelectOnUpManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _SelectOnUpManager_tree.set(this, viewer_shared_node_tree_1.Tree.instance);
        _SelectOnUpManager_deselectOnEmpty.set(this, true);
        _SelectOnUpManager_effectMaterialToken.set(this, void 0);
        _SelectOnUpManager_filter.set(this, (interactionState) => {
            if (interactionState === IInteractionEngine_1.INTERACTION_STATE.UP) {
                return (node) => {
                    for (let i = 0; i < node.data.length; i++) {
                        if (node.data[i] instanceof InteractionData_1.InteractionData) {
                            if (node.data[i].interactionTypes.select)
                                return true;
                        }
                    }
                    return false;
                };
            }
            return (node) => false;
        });
        _SelectOnUpManager_groupEffectMaterialToken.set(this, void 0);
        _SelectOnUpManager_groupedNodes.set(this, void 0);
        _SelectOnUpManager_intersection.set(this, null);
        _SelectOnUpManager_node.set(this, null);
        // #endregion Private Methods (2)
    }
    // #endregion Properties (9)
    // #region Public Getters And Setters (3)
    /**
     * Deselect the selected node when clicking on an empty space in the Viewport.
     */
    get deselectOnEmpty() {
        return __classPrivateFieldGet(this, _SelectOnUpManager_deselectOnEmpty, "f");
    }
    /**
     * Deselect the selected node when clicking on an empty space in the Viewport.
     */
    set deselectOnEmpty(value) {
        __classPrivateFieldSet(this, _SelectOnUpManager_deselectOnEmpty, value, "f");
    }
    get filter() {
        return __classPrivateFieldGet(this, _SelectOnUpManager_filter, "f");
    }
    // #endregion Public Getters And Setters (3)
    // #region Public Methods (7)
    add(viewport) {
        this.viewport = viewport;
    }
    /**
     * Deselect the current node.
     */
    deselect() {
        if (__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"))
            this.deactivateNode();
    }
    onDown(event, ray, intersection) {
        if (!this.viewport)
            throw new viewer_shared_services_1.ShapeDiverViewerInteractionError('The interaction manager does not belong to an interaction engine. Please add it to one first.');
    }
    onEnd(event, ray, intersection, endState) {
        if (!this.viewport)
            throw new viewer_shared_services_1.ShapeDiverViewerInteractionError('The interaction manager does not belong to an interaction engine. Please add it to one first.');
        if (endState === IInteractionEngine_1.INTERACTION_STATE.UP) {
            const intersections = intersection.filter(i => this.filter(IInteractionEngine_1.INTERACTION_STATE.UP)(i.node));
            if (__classPrivateFieldGet(this, _SelectOnUpManager_node, "f")) {
                if (intersections.length > 0 && intersection[0].node !== __classPrivateFieldGet(this, _SelectOnUpManager_node, "f")) {
                    // case other node was clicked, deselect then select
                    this.deactivateNode(event);
                    this.activateNode(intersections[0], event, ray);
                }
                else if (intersections.length > 0 && intersection[0].node === __classPrivateFieldGet(this, _SelectOnUpManager_node, "f")) {
                    // case same node was clicked, only deselect
                    this.deactivateNode(event);
                }
                else if (intersections.length === 0 && __classPrivateFieldGet(this, _SelectOnUpManager_deselectOnEmpty, "f")) {
                    // case no node was clicked, only deselect when option is on
                    this.deactivateNode(event);
                }
            }
            else if (intersections.length > 0) {
                // easy case, no node select, just select this one
                this.activateNode(intersections[0], event, ray);
            }
        }
    }
    onMove(event, ray, intersection) {
        if (!this.viewport)
            throw new viewer_shared_services_1.ShapeDiverViewerInteractionError('The interaction manager does not belong to an interaction engine. Please add it to one first.');
    }
    remove() {
        if (__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"))
            this.deactivateNode();
        this.viewport = undefined;
    }
    /**
     * Select a node.
     * The point and distance of the intersection can be freely chosen and are provided in the event callbacks.
     *
     * @param intersection
     */
    select(intersection) {
        if (__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"))
            this.deactivateNode();
        this.activateNode(intersection);
    }
    // #endregion Public Methods (7)
    // #region Private Methods (2)
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     * @param event
     * @param ray
     */
    activateNode(intersection, event, ray) {
        if (!this.viewport)
            throw new viewer_shared_services_1.ShapeDiverViewerInteractionError('The interaction manager does not belong to an interaction engine. Please add it to one first.');
        __classPrivateFieldSet(this, _SelectOnUpManager_intersection, intersection, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_node, __classPrivateFieldGet(this, _SelectOnUpManager_intersection, "f").node, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_groupedNodes, undefined, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_groupEffectMaterialToken, undefined, "f");
        // find the interaction data
        const data = __classPrivateFieldGet(this, _SelectOnUpManager_node, "f").data.find((d) => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates.select = true;
        // find and store all nodes that are within the group
        if (data.groupId) {
            __classPrivateFieldSet(this, _SelectOnUpManager_groupedNodes, this.gatheredGroupedNodes[data.groupId] || [], "f");
            __classPrivateFieldSet(this, _SelectOnUpManager_groupEffectMaterialToken, [], "f");
        }
        // apply the effect material if there is something to apply
        if (this.effectMaterial) {
            __classPrivateFieldSet(this, _SelectOnUpManager_effectMaterialToken, this.interactionEffectUtils.applyEffectMaterial(__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"), this.effectMaterial), "f");
            if (__classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f"))
                __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f").forEach(n => __classPrivateFieldGet(this, _SelectOnUpManager_groupEffectMaterialToken, "f").push(this.interactionEffectUtils.applyEffectMaterial(n, this.effectMaterial)));
        }
        else {
            __classPrivateFieldSet(this, _SelectOnUpManager_effectMaterialToken, undefined, "f");
        }
        this.viewport.updateNode(__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"));
        if (__classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f"))
            __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f").forEach(n => this.viewport.updateNode(n));
        this.viewport.render();
        __classPrivateFieldGet(this, _SelectOnUpManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.SELECT_ON, {
            viewportId: this.viewport.id,
            node: __classPrivateFieldGet(this, _SelectOnUpManager_node, "f"),
            intersectionPoint: __classPrivateFieldGet(this, _SelectOnUpManager_intersection, "f").point,
            ray,
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f")
        });
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param event
     */
    deactivateNode(event) {
        if (!this.viewport)
            throw new viewer_shared_services_1.ShapeDiverViewerInteractionError('The interaction manager does not belong to an interaction engine. Please add it to one first.');
        // find the interaction data
        const data = __classPrivateFieldGet(this, _SelectOnUpManager_node, "f").data.find((d) => d instanceof InteractionData_1.InteractionData);
        if (data)
            data.interactionStates.select = false;
        if (__classPrivateFieldGet(this, _SelectOnUpManager_effectMaterialToken, "f")) {
            this.interactionEffectUtils.removeEffectMaterial(__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"), __classPrivateFieldGet(this, _SelectOnUpManager_effectMaterialToken, "f"));
            __classPrivateFieldSet(this, _SelectOnUpManager_effectMaterialToken, undefined, "f");
            if (__classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f"))
                __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f").forEach((n, i) => this.interactionEffectUtils.removeEffectMaterial(n, __classPrivateFieldGet(this, _SelectOnUpManager_groupEffectMaterialToken, "f")[i]));
            __classPrivateFieldSet(this, _SelectOnUpManager_groupEffectMaterialToken, undefined, "f");
        }
        this.viewport.updateNode(__classPrivateFieldGet(this, _SelectOnUpManager_node, "f"));
        if (__classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f"))
            __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f").forEach(n => this.viewport.updateNode(n));
        this.viewport.render();
        __classPrivateFieldGet(this, _SelectOnUpManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.SELECT_OFF, {
            viewportId: this.viewport.id,
            node: __classPrivateFieldGet(this, _SelectOnUpManager_node, "f"),
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _SelectOnUpManager_groupedNodes, "f")
        });
        __classPrivateFieldSet(this, _SelectOnUpManager_intersection, null, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_node, null, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_groupedNodes, undefined, "f");
        __classPrivateFieldSet(this, _SelectOnUpManager_groupEffectMaterialToken, undefined, "f");
    }
}
exports.SelectOnUpManager = SelectOnUpManager;
_SelectOnUpManager_eventEngine = new WeakMap(), _SelectOnUpManager_tree = new WeakMap(), _SelectOnUpManager_deselectOnEmpty = new WeakMap(), _SelectOnUpManager_effectMaterialToken = new WeakMap(), _SelectOnUpManager_filter = new WeakMap(), _SelectOnUpManager_groupEffectMaterialToken = new WeakMap(), _SelectOnUpManager_groupedNodes = new WeakMap(), _SelectOnUpManager_intersection = new WeakMap(), _SelectOnUpManager_node = new WeakMap();
//# sourceMappingURL=SelectOnUpManager.js.map